import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import classes from './index.module.scss'
import {
  checkItems,
  selectChecked,
  selectPage,
  selectPageSize,
  uncheckAllItem,
} from './store/slice'

const Count = ({ deleteTemplate, total, ids }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectChecked)
  const page = useSelector(selectPage)
  const pageSize = useSelector(selectPageSize)

  const [isShowPopupDelete, setIsShowPopupDelete] = useState(false)

  const idsChecked = Object.keys(checked)

  const length = idsChecked.length

  const deleteAllChecked = () => {
    deleteTemplate({
      param: { ids: idsChecked },
      paramGet: {
        Page: page,
        PageSize: pageSize,
      },
    })
    dispatch(uncheckAllItem())
    closePopupDelete()
  }

  const selectAll = () => {
    dispatch(checkItems(ids))
  }

  const unSelectAll = () => {
    dispatch(uncheckAllItem())
  }

  const openPopupDelete = () => setIsShowPopupDelete(true)

  const closePopupDelete = () => setIsShowPopupDelete(false)

  const lengthItemSelect = total

  return (
    <div className={`dFlex alignItemsCenter ${classes.h32px}`}>
      <span className="fw600">
        <Translate value="preferenceSetting.SELECTED_1" />
        {length}{' '}
        <Translate
          value={`preferenceSetting.${length > 1 ? 'ITEMS' : 'ITEM'}`}
        />{' '}
        <Translate value="preferenceSetting.SELECTED_2" />
        &nbsp;
      </span>
      {length === lengthItemSelect ? (
        <Element
          elementName="span"
          style={{ color: '#2C73E8' }}
          className="fw600 cursorPointer"
          onClick={unSelectAll}
        >
          <Translate value="preferenceSetting.UNSELECT" />
        </Element>
      ) : (
        <Element
          elementName="span"
          style={{ color: '#2C73E8' }}
          className="fw600 cursorPointer"
          onClick={selectAll}
        >
          <Translate value="preferenceSetting.SELECT_ALL" />
          {Math.max(lengthItemSelect, 0)}
          <Translate
            value={`preferenceSetting.${
              lengthItemSelect > 1 ? 'ITEMS_2' : 'ITEM_2'
            }`}
          />
        </Element>
      )}
      {!!length && (
        <Element
          style={{ background: '#F2F7FF', color: '#2C73E8' }}
          className={classes.deleteAll}
          onClick={openPopupDelete}
        >
          <Icon className="icon-trash-fill" />
        </Element>
      )}
      <PopupAction
        isShow={isShowPopupDelete}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={closePopupDelete}
        btnCancel={{
          label: 'common.NO',
          event: closePopupDelete,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: deleteAllChecked,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.DELETE_CONFIRM_3" />
      </PopupAction>
    </div>
  )
}

export default Count
